import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { categories, gossipItems } from "@/mocks/gossip";
import VideoCard from "@/components/base/VideoCard";

const tabs = [{ slug: "all", name: "全部内容" }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function LatestSection() {
  const [activeTab, setActiveTab] = useState("all");

  const list = useMemo(() => {
    const sorted = [...gossipItems].sort((a, b) => (a.date < b.date ? 1 : -1));
    if (activeTab === "all") return sorted;
    return sorted.filter((item) => item.category === activeTab);
  }, [activeTab]);

  const activeCategory = categories.find((c) => c.slug === activeTab);

  return (
    <section id="latest" aria-labelledby="latest-title" className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 uppercase mb-2">
            <span className="w-4 h-px bg-primary-500"></span>
            Latest Feed
          </span>
          <h2 id="latest-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新现场内容流
          </h2>
        </div>
        <Link
          to={activeTab === "all" ? "/category/first-scene" : `/category/${activeTab}`}
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-700 cursor-pointer transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          进入分类页
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>

      <div className="mb-6 flex flex-wrap items-center gap-2" role="tablist" aria-label="内容分类筛选">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.slug}
            onClick={() => setActiveTab(tab.slug)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
              activeTab === tab.slug
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {activeCategory ? (
        <p className="mb-6 rounded-lg border border-background-200 bg-background-100 px-4 py-3 text-sm text-foreground-600">
          <i className="ri-information-line w-4 h-4 mr-1.5 inline-flex items-center justify-center text-primary-500 align-middle"></i>
          {activeCategory.description}
        </p>
      ) : null}

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {list.map((item) => (
          <VideoCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}